import { NumericTextBox } from "@progress/kendo-react-inputs";
import { currencies } from "../../constants";

export default function CurrencySettings({ draft, onRateChange, t = {} }) {
  return (
    <div className="panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{t.currencies || "Currencies"}</p>
          <h3>{t.editableExchangeRates || "Editable exchange rates"}</h3>
        </div>
      </div>
      <p className="muted paragraph">
        {t.ratesHint || "Rates are stored locally and used to convert each expense from its original currency into your display currency."}
      </p>
      <div className="rate-grid">
        {currencies.map((currency) => (
          <div className="field" key={currency.value}>
            <label>{(t.ratePerUsd || ((code) => `${code} per 1 USD`))(currency.value)}</label>
            <NumericTextBox
              value={draft.exchangeRates[currency.value]}
              min={0}
              format="n4"
              disabled={currency.value === "USD"}
              onChange={(event) => onRateChange(currency.value, event.value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
